// const Section4 = () => {
//   return (
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-center mb-20">
//       {/* Left Column: image */}
//       <div className="flex justify-center ml-64">
//         <img
//           src={face}
//           alt="Portrait"
//           className="w-[450px] h-auto object-cover rounded-lg shadow-md max-w-md ml-96"
//         />
//       </div>

//       {/* Right Column: content */}
//       <div className="text-black-900 text-justify flex flex-col justify-center items-start md:ml-[98px] ">
//         <div className="w-[600px]">
//           <h1
//             className="text-3xl md:text-4xl "
//             style={{
//               fontFamily: "Blacker Pro Display",
//             }}
//           >
//             Your brand tells your story, and we believe in creating minimalist
//             designs that capture the true essence of your brand
//           </h1>
//           <br />

//           <p
//             className="text-gray-600 text-[17px] leading-relaxed tracking-wide "
//             style={{
//               fontFamily: "Lato-Regular",
//             }}
//           >
//             My approach is all about putting you and your vision at the
//             forefront. With custom branding, web design, and social media
//             strategies tailored to your unique needs, every detail is crafted
//             with intention. <br /> <br />
//             We understand the unique goals of ambitious founders and blend
//             creativity with strategy to deliver a high-end, minimalistic design
//             that speaks volumes. Working closely with you, we bring your vision
//             to life through impactful content and strategic marketing that
//             elevates your brand's online presence and makes a lasting impact.
//           </p>
//         </div>
//         <div className="mt-20  ">
//           <button className="bg-[#704735] text-white px-8 py-4 rounded-md text-sm cursor-pointer self-center tracking-widest ">
//             INQUIRE
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Section4;
import React from "react";
import face from "../../Assets/Contact.JPG";
import { Link } from "react-router-dom";

const Section4 = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center justify-center mb-10 lg:mb-20 px-4 lg:px-16">
      {/* Left Column: image */}
      <div className="flex justify-end mt-10 lg:justify-end">
        <img
          src={face}
          alt="Portrait"
          className="w-[65%] lg:w-[430px] h-auto object-cover rounded-lg shadow-md"
        />
      </div>

      {/* Right Column: content */}
      <div className="text-black-900 text-justify flex flex-col justify-center ">
        <div className="w-full lg:w-[600px] lg:pr-16">
          <h1
            className="text-3xl lg:text-4xl text-left md:text-justify"
            style={{
              fontFamily: "Blacker Pro Display",
            }}
          >
            Your brand tells your story, and we believe in creating minimalist
            designs that capture the true essence of your brand
          </h1>
          <br />
          <p
            className="text-gray-600 lg:text-xl leading-relaxed tracking-wide"
            style={{
              fontFamily: "Lato-Regular",
            }}
          >
            My approach is all about putting you and your vision at the
            forefront. With custom branding, web design, and social media
            strategies tailored to your unique needs, every detail is crafted
            with intention.
            <br />
            <br />
            We understand the unique goals of ambitious founders and blend
            creativity with strategy to deliver a high-end, minimalistic design
            that speaks volumes. Working closely with you, we bring your vision
            to life through impactful content and strategic marketing that
            elevates your brand's online presence and makes a lasting impact.
          </p>
        </div>
        <div className="mt-8 lg:mt-10 w-full flex lg:block justify-center ">
          <Link to="/about">
            <button className="bg-[#704735] text-white px-8 py-4 rounded-md text-sm cursor-pointer tracking-widest">
              INQUIRE
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Section4;
